(() => {
  const key = 'laflore:product-breadcrumb';
  const context = document.querySelector('meta[name="product-breadcrumb-context"]')?.dataset;
  if (!context) return;
  const productPath = path => /\/products\/[^/]+\/?$/.test(path);
  const collectionUrl = value => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /^\/(?:[^/]+\/)?collections\/[^/]+\/?$/.test(url.pathname) ? url.pathname : null;
    } catch { return null; }
  };
  const validSource = source => source?.title && collectionUrl(source.url)
    ? { title: source.title, url: collectionUrl(source.url) } : null;
  let previous;
  try { previous = JSON.parse(sessionStorage.getItem(key)); } catch { /* Storage may be unavailable. */ }
  const save = source => {
    try {
      if (source) sessionStorage.setItem(key, JSON.stringify({ source, lastProduct: context.pageType === 'product' ? location.pathname : null }));
      else sessionStorage.removeItem(key);
    } catch { /* Breadcrumbs still work without session storage. */ }
  };

  async function resolveSource() {
    const current = validSource({ title: context.collectionTitle, url: context.collectionUrl });
    if (context.pageType !== 'product') return context.pageType === 'collection' ? current : null;
    let referrer;
    try { referrer = new URL(document.referrer); } catch { /* Direct visit. */ }
    const sameSite = referrer?.origin === location.origin;
    const stored = validSource(previous?.source);
    // Only carry a source forward from the product we actually navigated from.
    if (sameSite && productPath(referrer.pathname) && previous?.lastProduct === referrer.pathname) return stored;
    const navigation = performance.getEntriesByType('navigation')[0]?.type;
    if (['reload', 'back_forward'].includes(navigation) && previous?.lastProduct === location.pathname) return stored || current;
    if (sameSite && collectionUrl(referrer.pathname)) {
      const url = collectionUrl(referrer.pathname);
      if (stored?.url === url) return stored;
      if (current?.url === url) return current;
      // New tabs or blocked storage can lose the collection landing-page record.
      // Read our collection metadata only in that exceptional case.
      try {
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = doc.querySelector('meta[name="product-breadcrumb-context"]')?.dataset;
        return validSource({ title: data?.collectionTitle, url: data?.collectionUrl });
      } catch { return null; }
    }
    return current;
  }

  const sourceReady = resolveSource().then(source => {
    save(source);
    // A cached collection/product page must also restore its own journey record.
    window.addEventListener('pageshow', event => { if (event.persisted) save(source); });
    return source;
  });

  customElements.define('product-breadcrumb', class extends HTMLElement {
    connectedCallback() {
      sourceReady.then(source => {
        if (!this.isConnected) return;
        this.querySelectorAll('[data-breadcrumb-collection]').forEach(slot => {
          slot.hidden = !source;
          if (source) {
            const link = slot.querySelector('a');
            link.textContent = source.title;
            link.setAttribute('href', source.url);
          }
        });
      });
    }
  });
})();
